import React, { useEffect, useState } from "react";
import "./index.css";
import Constant from "constants/index";
import { Col, Row, Container } from "reactstrap";
import DeckGL from "@deck.gl/react";
import { MapView, WebMercatorViewport, MapController } from "@deck.gl/core";
import {
  DrawPolygonMode,
  ViewMode,
  MeasureDistanceMode,
} from "nebula.gl";
import MapToolTips from "./MapToolTips";
import SearchBox from "../../components/SearchBox";
import MenuActions from "pages/StorePlanning/components/Menu/MenuActions";
import MenuToggle from "pages/StorePlanning/components/Menu/MenuToggle";
import MapLayer from "pages/StorePlanning/components/MapLayer";
import ApiCaller from "api/apiCaller";
import RightCorner from "pages/StorePlanning/components/RightCorner";
import PolygonInfoModal from "../../components/PolygonInfoModal";
import PolygonCommentModal from "../../components/PolygonCommentModal";
const { StaticMap } = require("react-map-gl");

let timeoutMapStateChange: any = null,
  asyncTime = 100;

type PlanningMapProps = {
  latitude?: number;
  longitude?: number;
  defaultMapStyle?: any;
  embedMode?: boolean;
  showNearbyLocationFirst: boolean;
};

const PlanningMap = ({
  defaultMapStyle,
  embedMode,
  latitude,
  longitude,
  showNearbyLocationFirst,
}: PlanningMapProps) => {
  const initialViewState = {
    latitude: latitude || 10.77653,
    longitude: longitude || 106.700981,
    zoom: 15,
    pitch: 0,
    bearing: 0,
  };

  useEffect(() => {
    document.title = "LISA Planning Map";
    getCurrentUser();
    getWards();
    document.addEventListener("keydown", escFunction, false);
    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, []);

  const getWards = async () => {
    if (!state.mapBoundary) return null;
    setState((state) => ({ ...state, isGetWardsDemographics: true }));
    const res = await ApiCaller.post("ward/by_boundary", state.mapBoundary);
    if (res.status === "ok") {
      setState((state) => ({
        ...state,
        isGetWardsDemographics: false,
        wards: res.wards,
      }));
      // getWardsDemographics()
    } else {
      setState((state) => ({ ...state, isGetWardsDemographics: false }));
    }
  };

  const getWardsDemographics = async () => {
    const wardIds = state.wards.map((ward: any) => ward.id) || [];
    if (wardIds.length <= 0) return;
    const requestBody = {
      wards: wardIds,
    };
    setState((state) => ({ ...state, isGetWardsDemographics: true }));
    const wardRes = await ApiCaller.post("ward/demographics", requestBody);
    if (wardRes.status === "ok") {
      setState((state) => ({
        ...state,
        summaryData: wardRes.summary,
        isGetWardsDemographics: false,
      }));
    } else {
      setState((state) => ({ ...state, isGetWardsDemographics: false }));
    }
  };

  const getCurrentUser = async () => {
    const userRes = await ApiCaller.get(
      "userme/me?include_permissions=planning_map"
    );
    if (userRes.result) {
      setState((state) => ({
        ...state,
        currentUser: userRes.result,
      }));
    }
  };

  const escFunction = (event: any) => {
    if (event.keyCode === 27) {
      setState((state) => ({
        ...state,
        isEnableDrawing: false,
        mapMode: ViewMode,
      }));
    }
  };

  const [state, setState] = useState({
    gettingCurrentLocation: false,
    currentLocation: {
      latitude: latitude ? latitude : 10.77653,
      longitude: longitude ? longitude : 106.700981,
    },
    initialViewState,
    debugMode: false,
    wards: [],
    drawingGeoJson: Constant.DEFAULT_GEOJSON_DRAWING,
    planningPolygons: [],
    showPlanningPolygon: false,
    selectedFeatureIndexes: [],
    isEnableDrawing: false,
    isEnableSelection: false,
    isShowToolbar: false,
    mapMode: ViewMode,
    isShowPolygonInfoModal: false,
    mapStyle: defaultMapStyle || Constant.MAP_STYLES[0],
    mapSettings: {
      showWardBoundary: false,
      showWardDensity: false,
      showPlanningZoneTitle: false,
    },
    selectedNearbyLocationTypesToShow: [],
    planningPolygonHoveredObject: null,
    nearbyLocationHoveredObject: null,
    nearbyLocationClickedObject: null,
    wardHoveredObject: null,
    externalRetailDemandHoveredObject: null,
    trafficCountingPointHoveredObject: null,
    mapBoundaryGeoJson: null,
    mapBoundary: null,
    isGetWardsDemographics: false,
    currentUser: null,
    nearbyLocations: [],
    isShowCommentPopup: false,
    planningPolygonToEdit: null,
    planningPolygonToShowComment: null,
  });

  useEffect(() => {
    getWardsDemographics();
  }, [state.wards]);

  useEffect(() => {
    if (state.showPlanningPolygon) {
      getSitePlanningPolygon();
    }
  }, [state.showPlanningPolygon]);

  useEffect(() => {
    getNearbyLocationDetail();
  }, [state.selectedNearbyLocationTypesToShow]);

  const checkUserPermissions = (
    permissionGroupName: string,
    permissionName: string
  ) => {
    const currentUser: any = state.currentUser;
    if (!currentUser) return false;
    if (!currentUser?.permissions?.planning_map?.[permissionGroupName])
      return false;
    return currentUser.permissions.planning_map[permissionGroupName].includes(
      permissionName
    );
  };

  const getExternalFoodAndBeverageCategories = async () => {
    if (
      !checkUserPermissions(
        "ExternalFoodAndBeverageDataModelApi",
        "can_get_external_fnb_data_by_category_boundary"
      )
    )
      return;
    setState((state) => ({ ...state, isGetExternalFoodAndBeverageData: true }));
    if (!state.mapBoundary) return null;
    const res = await ApiCaller.post(
      "external_food_and_beverage_data/by_boundary/category",
      state.mapBoundary
    );
    if (res.status === "ok") {
      setState((state) => ({
        ...state,
        foodAndBeverageCategoryDemand: res,
        isGetExternalFoodAndBeverageData: false,
      }));
    } else {
      setState((state) => ({
        ...state,
        isGetExternalFoodAndBeverageData: false,
      }));
    }
  };
  const getExternalRetailData = async () => {
    if (
      !checkUserPermissions(
        "ExternalRetailDataModelApi",
        "can_get_external_retail_data_by_boundary"
      )
    )
      return;
    setState((state) => ({ ...state, isGetExternalRetailData: true }));
    if (!state.mapBoundary) return null;
    const res = await ApiCaller.post(
      "external_retail_data/by_boundary",
      state.mapBoundary
    );
    if (res.status === "ok") {
      setState((state) => ({
        ...state,
        externalRetailDemand: res,
        isGetExternalRetailData: false,
      }));
    } else {
      setState((state) => ({
        ...state,
        isGetExternalRetailData: false,
      }));
    }
  };
  const getExternalFoodAndBeverageDeliveryData = async () => {
    if (
      !checkUserPermissions(
        "ExternalFoodAndBeverageDeliveryDataModelApi",
        "can_get_external_fnb_delivery_data_by_boundary"
      )
    )
      return;
    setState((state) => ({
      ...state,
      isGetExternalFoodAndBeverageDeliveryData: true,
    }));
    if (!state.mapBoundary) return null;
    const res = await ApiCaller.post(
      "external_food_and_beverage_delivery_data/by_boundary",
      state.mapBoundary
    );
    if (res.status === "ok") {
      setState((state) => ({
        ...state,
        foodAndBeverageDeliveryDemand: res.food_and_beverage_delivery_demand,
        isGetExternalFoodAndBeverageDeliveryData: false,
      }));
    } else {
      setState((state) => ({
        ...state,
        isGetExternalFoodAndBeverageDeliveryData: false,
      }));
    }
  };
  const getStaticDemandData = async () => {
    if (
      !checkUserPermissions(
        "ExternalDropOffLocationDataModelApi",
        "can_get_external_drop_off_location_data_by_boundary"
      )
    )
      return;
    setState((state) => ({ ...state, isGetStaticDemandData: true }));
    if (!state.mapBoundary) return null;
    const res = await ApiCaller.post(
      "external_static_demand_data/by_boundary",
      state.mapBoundary
    );
    if (res.status === "ok") {
      setState((state) => ({
        ...state,
        staticDemand: res.static_demand,
        isGetStaticDemandData: false,
      }));
    } else {
      setState((state) => ({
        ...state,
        isGetStaticDemandData: false,
      }));
    }
  };

  const getExternalFoodAndBeverageData = async () => {
    if (
      !checkUserPermissions(
        "ExternalFoodAndBeverageDataModelApi",
        "can_get_external_fnb_data_by_boundary"
      )
    )
      return;
    setState((state) => ({ ...state, isGetExternalFoodAndBeverageData: true }));
    if (!state.mapBoundary) return null;
    const res = await ApiCaller.post(
      "external_food_and_beverage_data/by_boundary",
      state.mapBoundary
    );
    if (res.status === "ok") {
      setState((state) => ({
        ...state,
        foodAndBeverageDemand: res.food_and_beverage_demand,
        isGetExternalFoodAndBeverageData: false,
      }));
    } else {
      setState((state) => ({
        ...state,
        isGetExternalFoodAndBeverageData: false,
      }));
    }
  };

  const getNearbyLocationSummary = async () => {
    if (
      !checkUserPermissions(
        "LocationModelApi",
        "can_get_location_type_group_by_boundary"
      )
    )
      return;
    setState((state) => ({ ...state, isGetNearbyLocationSummary: true }));
    if (!state.mapBoundary) return null;
    const res = await ApiCaller.post(
      "location/by_boundary/group_by/location_type",
      state.mapBoundary
    );
    if (res.status === "ok") {
      setState((state) => ({
        ...state,
        nearbyLocationTypeSummary: res.result,
        isGetNearbyLocationSummary: false,
      }));
    } else {
      setState((state) => ({
        ...state,
        isGetNearbyLocationSummary: false,
      }));
    }
  };

  const getNearbyLocationDetail = async () => {
    const { mapBoundary, selectedNearbyLocationTypesToShow }: any = state;
    setState((state) => ({
      ...state,
      isGetNearbyLocationSummary: true,
    }));
    if (selectedNearbyLocationTypesToShow.length === 0) {
      setState((state) => ({
        ...state,
        isGetNearbyLocationSummary: false,
        nearbyLocations: [],
      }));
    }
    if (!mapBoundary || selectedNearbyLocationTypesToShow.length <= 0)
      return null;
    const res = await ApiCaller.post("location/by_boundary/list", {
      ...mapBoundary,
      location_type_id_list: selectedNearbyLocationTypesToShow.map(
        (locationType: any) => locationType.location_type_id
      ),
    });
    if (res.status === "ok") {
      setState((state) => ({
        ...state,
        isGetNearbyLocationSummary: false,
        nearbyLocations: res.result.locations,
      }));
    } else {
      setState((state) => ({
        ...state,
        isGetNearbyLocationSummary: false,
      }));
    }
  };

  const getSitePlanningPolygon = async () => {
    const { mapBoundary, showPlanningPolygon }: any = state;
    if (!showPlanningPolygon) return;
    const res = await ApiCaller.post(
      "site_planning_selection_area/list?limit=10000",
      mapBoundary
    );
    if (res.status === "ok") {
      const planningPolygonsTransformed = res.result.map(
        (planningPolygon: any) => {
          const newPlanningPolygon = planningPolygon;
          const newPlanningPolygonGeoJson = JSON.parse(
            newPlanningPolygon.geojson
          );
          newPlanningPolygonGeoJson.features[0].properties = planningPolygon;
          return {
            ...newPlanningPolygonGeoJson,
            properties: planningPolygon,
          };
        }
      );
      setState((state) => ({
        ...state,
        planningPolygons: planningPolygonsTransformed,
        showPlanningPolygon: true,
      }));
    }
  };

  useEffect(() => {
    getWards();
    getExternalFoodAndBeverageCategories();
    getExternalFoodAndBeverageData();
    getExternalFoodAndBeverageDeliveryData();
    getStaticDemandData();
    getNearbyLocationSummary();
    getNearbyLocationDetail();
    getSitePlanningPolygon();
    getExternalRetailData();
  }, [state.mapBoundary]);

  const handleMapViewStateChange = (mapState: any) => {
    timeoutMapStateChange && clearTimeout(timeoutMapStateChange);
    timeoutMapStateChange = setTimeout(() => {
      const { viewState } = mapState;
      const viewport = new WebMercatorViewport(viewState);
      getMapBoundary(viewport);
    }, asyncTime);
  };

  const getMapBoundary = (viewport: any) => {
    const nw = viewport.unproject([0, 0]);
    const se = viewport.unproject([viewport.width, viewport.height]);
    const ne = viewport.unproject([viewport.width, 0]);
    const sw = viewport.unproject([0, viewport.height]);
    const mapBoundary: any = {
      nw,
      ne,
      se,
      sw,
    };
    const mapBoundaryGeoJson: any = {
      geometry: {
        coordinates: [[nw, ne, se, sw, nw]],
        type: "Polygon",
      },
      properties: {
        name: "XXX",
      },
      type: "Feature",
    };
    setState((state) => ({
      ...state,
      mapBoundary,
      mapBoundaryGeoJson,
    }));
  };

  const navigateToLocation = (location: any) => {
    const newViewState = {
      latitude: location.lat,
      longitude: location.lng,
      zoom: 16.5,
      pitch: 0,
      bearing: 0,
    };
    setState((state) => ({
      ...state,
      initialViewState: newViewState,
      gettingCurrentLocation: false,
      currentLocation: {
        latitude: location.lat,
        longitude: location.lng,
      },
    }));
  };

  const goToSelectedLocation = (selectedItem: any) => {
    if (selectedItem?.geometry?.location) {
      const selectedItemLocation = selectedItem?.geometry?.location;
      navigateToLocation(selectedItemLocation);
    }
  };

  const getCurrentPosition = () => {
    setState((state) => ({ ...state, gettingCurrentLocation: true }));
    navigator.geolocation.getCurrentPosition(
      (position) => {
        navigateToLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      (err) => {
        alert("Error code " + err.code + ": " + err.message);
        setState((state) => ({ ...state, gettingCurrentLocation: false }));
      }
    );
  };

  const toggleMeasureMode = () => {
    setState((state) => ({
      ...state,
      mapMode:
        state.mapMode === MeasureDistanceMode ? ViewMode : MeasureDistanceMode,
    }));
  };

  const toggleDrawingMode = () => {
    setState((state) => ({
      ...state,
      isEnableDrawing: !state.isEnableDrawing,
      mapMode: state.isEnableDrawing ? ViewMode : DrawPolygonMode,
    }));
  };
  const toggleSelectionMode = () => {
    setState((state) => ({
      ...state,
      isEnableSelection: !state.isEnableSelection,
      selectedFeatureIndexes: [],
    }));
  };

  const toggleMapToolbar = () => {
    setState((state) => ({
      ...state,
      isShowToolbar: !state.isShowToolbar,
    }));
  };

  const changeZoomLevel = (incrementalLevel: number) => () => {
    setState((state) => ({
      ...state,
      initialViewState: {
        ...state.initialViewState,
        zoom: state.initialViewState.zoom + incrementalLevel,
      },
    }));
  };

  const mapDrawingEditHandler = (data: any) => {
    const { updatedData, editType } = data;
    console.log(updatedData)
    setState((state) => ({ ...state, drawingGeoJson: updatedData }));
    // TODO: Double check editType with DrawLineStringMode
    if (editType === "addFeature") {
      setState((state) => ({ ...state, isShowPolygonInfoModal: true }));
    }
  };

  const onHoverLayer = (attribute: string) => (data: any) => {
    const { object, x, y } = data;
    setState((state) => ({
      ...state,
      [attribute]: object,
      pointerX: x,
      pointerY: y,
    }));
  };

  const onNearbyLocationItemClick = ({ object, x, y }: any) => {
    let baseUrl = `/market_information/${object.id}`;
    if (object.site_id && !object.store_id) {
      baseUrl = `/sitev2/${object.site_id}`;
    }
    if (object.site_id && object.store_id) {
      baseUrl = `/store/${object.store_id}`;
    }
    window.open(
      baseUrl,
      "_blank" // <- This is what makes it open in a new window.
    );
  };

  const onPlanningPolygonItemClick = (selectedFeatureIndex: number) => {
    const selectedFeatureIndexes: any = [selectedFeatureIndex];
    setState((state) => ({
      ...state,
      selectedFeatureIndexes,
    }));
  };

  const setSelectedFeatureIndexes = ({ pickingInfos }: any) => {
    setState((state) => ({ ...state, selectedFeatureIndexes: pickingInfos }));
  };

  const getExternalFoodAndBeverageDeliveryPoints = async () => {
    if (
      !checkUserPermissions(
        "ExternalFoodAndBeverageDeliveryDataModelApi",
        "can_list_with_condition"
      )
    )
      return;
    setState((state) => ({
      ...state,
      isGetExternalFoodAndBeverageDeliveryData: true,
    }));
    if (!state.mapBoundary) return null;
    const res = await ApiCaller.post(
      "external_food_and_beverage_delivery_data/by_boundary/list",
      state.mapBoundary
    );
    if (res.status === "ok") {
      setState((state) => ({
        ...state,
        foodAndBeverageDeliveryTransactions:
          res.food_and_beverage_delivery_transactions,
        isGetExternalFoodAndBeverageDeliveryData: false,
      }));
    } else {
      setState((state) => ({
        ...state,
        isGetExternalFoodAndBeverageDeliveryData: false,
      }));
    }
  };

  const getExternalFoodAndBeveragePoints = async () => {
    if (
      !checkUserPermissions(
        "ExternalFoodAndBeverageDataModelApi",
        "can_list_with_condition"
      )
    )
      return;
    setState((state) => ({
      ...state,
      isGetExternalFoodAndBeverageData: true,
    }));
    if (!state.mapBoundary) return null;
    const res = await ApiCaller.post(
      "external_food_and_beverage_data/by_boundary/list",
      state.mapBoundary
    );
    if (res.status === "ok") {
      setState((state) => ({
        ...state,
        foodAndBeverageTransactions: res.food_and_beverage_transactions,
        isGetExternalFoodAndBeverageData: false,
      }));
    } else {
      setState((state) => ({
        ...state,
        isGetExternalFoodAndBeverageData: false,
      }));
    }
  };

  const getExternalRetailDataDetail = async () => {
    if (
      !checkUserPermissions(
        "ExternalRetailDataModelApi",
        "can_get_external_retail_data_detail_by_boundary"
      )
    )
      return;
    setState((state) => ({
      ...state,
      isGetExternalRetailData: true,
    }));
    if (!state.mapBoundary) return null;
    const res = await ApiCaller.post(
      "external_retail_data/by_boundary/list",
      state.mapBoundary
    );
    if (res.status === "ok") {
      setState((state) => ({
        ...state,
        externalRetailDemandDetail: res.retail_demand,
        isGetExternalRetailData: false,
      }));
    } else {
      setState((state) => ({
        ...state,
        isGetExternalRetailData: false,
      }));
    }
  };

  const nearbyLocationTypeSelection = (dataToCallback: any) => {
    let newSelectedLocationTypes: any =
      [...state.selectedNearbyLocationTypesToShow] || [];
    if (dataToCallback.checkStatus) {
      newSelectedLocationTypes.push(dataToCallback.selectedItem);
    } else {
      newSelectedLocationTypes = newSelectedLocationTypes.filter(
        (locationType: any) =>
          locationType.location_type_id !==
          dataToCallback?.selectedItem?.location_type_id
      );
    }
    setState((state) => ({
      ...state,
      selectedNearbyLocationTypesToShow: newSelectedLocationTypes,
    }));
  };

  const setMapSettings = (attributeName: string, value: any) => {
    setState((state) => ({
      ...state,
      mapSettings: {
        ...state.mapSettings,
        [attributeName]: value,
      },
    }));
  };

  const setShowTrafficCounting = (isShow: boolean) => {
    setState((state) => ({ ...state, isShowTrafficCounting: isShow }));
  };

  const toggleSitePlanningCommentUI = (planningPolygon: any) => {
    setState((state) => ({
      ...state,
      isShowCommentPopup: !state.isShowCommentPopup,
      planningPolygonToShowComment: planningPolygon,
    }));
  };

  const editPlanningPolygon = (planningPolygon: any) => {
    setState((state) => ({
      ...state,
      isShowPolygonInfoModal: true,
      planningPolygonToEdit: planningPolygon,
    }));
  };

  const toggleShowPlanningPolygons = () => {
    setState((state) => ({
      ...state,
      showPlanningPolygon: !state.showPlanningPolygon,
    }));
  };

  const onPolygonSaved = () => {
    setState((state) => ({
      ...state,
      drawingGeoJson: Constant.DEFAULT_GEOJSON_DRAWING,
      isShowPolygonInfoModal: false,
      planningPolygonToEdit: null,
    }));
    getSitePlanningPolygon();
  };

  return (
    <div
      className={`site-planning__page-container ${
        embedMode ? "site-planning__embed-mode" : ""
      }`}
    >
      <Container fluid>
        <Row>
          <Col xs={12} sm={8} md={9} className="site-planning__section">
            <div
              className={`site-planning__map-container ${
                embedMode ? "site-planning__embed-mode" : ""
              }`}
            >
              <DeckGL
                getCursor={({ isDragging }) => {
                  if (isDragging) return "grabbing";
                  if (
                    state.mapMode == DrawPolygonMode ||
                    state.mapMode == MeasureDistanceMode
                  )
                    return "crosshair";
                  return "grab";
                }}
                height="calc(100vh - 60px)"
                width="100%"
                initialViewState={state.initialViewState}
                onViewStateChange={handleMapViewStateChange}
                layers={MapLayer({
                  mapDrawingEditHandler: mapDrawingEditHandler,
                  state: state,
                  onExternalRetailDemandItemHover: onHoverLayer(
                    "externalRetailDemandHoveredObject"
                  ),
                  onNearbyLocationItemClick: onNearbyLocationItemClick,
                  onNearbyLocationItemHover: onHoverLayer(
                    "nearbyLocationHoveredObject"
                  ),
                  onPlanningPolygonItemClick: onPlanningPolygonItemClick,
                  onPlanningPolygonItemHover: onHoverLayer(
                    "planningPolygonHoveredObject"
                  ),
                  onTrafficCountingPointHover: onHoverLayer(
                    "trafficCountingPointHoveredObject"
                  ),
                  onWardItemHover: onHoverLayer("wardHoveredObject"),
                  setSelectedFeatureIndexes: setSelectedFeatureIndexes,
                })}
                views={[
                  new MapView({
                    id: "basemap",
                    controller: {
                      type: MapController,
                      doubleClickZoom: false,
                    },
                  }),
                ]}
              >
                <StaticMap
                  mapStyle={`mapbox://styles/mapbox/${state.mapStyle.styleCode}`}
                  mapboxApiAccessToken={Constant.MAPBOX_API_ACCESS_TOKEN}
                />
              </DeckGL>
              <MapToolTips state={state} />
              <div className="site-planning__map-search-box">
                <SearchBox onItemClick={goToSelectedLocation} />
              </div>
              {!state.isShowToolbar && (
                <MenuActions
                  getCurrentPosition={getCurrentPosition}
                  gettingCurrentLocation={state.gettingCurrentLocation}
                  isEnableDrawing={state.isEnableDrawing}
                  isEnableSelection={state.isEnableSelection}
                  mapMode={state.mapMode}
                  toggleDrawingMode={toggleDrawingMode}
                  toggleMapToolbar={toggleMapToolbar}
                  toggleMeasureMode={toggleMeasureMode}
                  toggleSelectionMode={toggleSelectionMode}
                />
              )}
              {state.isShowToolbar && (
                <MenuToggle
                  isEnableSelection={state.isEnableSelection}
                  selectMapStyle={(mapStyle) =>
                    setState((state) => ({ ...state, mapStyle }))
                  }
                  setEnableSelection={(isEnable) =>
                    setState((state) => ({
                      ...state,
                      isEnableSelection: isEnable,
                    }))
                  }
                  toggleMapToolbar={toggleMapToolbar}
                />
              )}
              <div className="site-planning__map-toolbar zoom">
                <button
                  className="site-planning__map__zoom-button"
                  onClick={changeZoomLevel(0.5)}
                >
                  +
                </button>
                <button
                  className="site-planning__map__zoom-button"
                  onClick={changeZoomLevel(-0.5)}
                >
                  -
                </button>
              </div>
            </div>
          </Col>
          <RightCorner
            state={state}
            getExternalFoodAndBeverageDeliveryPoints={
              getExternalFoodAndBeverageDeliveryPoints
            }
            getExternalFoodAndBeveragePoints={getExternalFoodAndBeveragePoints}
            getExternalRetailDataDetail={getExternalRetailDataDetail}
            getStaticDemandPoints={getStaticDemandData}
            nearbyLocationTypeSelection={nearbyLocationTypeSelection}
            setMapSettings={setMapSettings}
            setShowTrafficCounting={setShowTrafficCounting}
            showNearbyLocationFirst={showNearbyLocationFirst}
            embedMode={embedMode}
            toggleSitePlanningCommentUI={toggleSitePlanningCommentUI}
            editPlanningPolygon={editPlanningPolygon}
            toggleShowPlanningPolygons={toggleShowPlanningPolygons}
          />
        </Row>
      </Container>
      {state.isShowPolygonInfoModal && (
        <PolygonInfoModal
          initialIsOpen={state.isShowPolygonInfoModal}
          geoJson={state.drawingGeoJson || state.planningPolygonToEdit}
          onPolygonSaved={onPolygonSaved}
          planningPolygonToEdit={state.planningPolygonToEdit}
          onCancelled={() =>
            setState((state) => ({ ...state, isShowPolygonInfoModal: false }))
          }
        />
      )}
      {state.isShowCommentPopup && (
        <PolygonCommentModal
          initialIsOpen={state.isShowCommentPopup}
          planningPolygonToShowComment={state.planningPolygonToShowComment}
          onCancelled={() =>
            setState((state) => ({ ...state, isShowCommentPopup: false }))
          }
        />
      )}
    </div>
  );
};

export default PlanningMap;
